module.exports = __webpack_public_path__ + "img/blue-Services-icon-1.6bd9a791.svg";